<template>
  <form data-vv-scope="data-user">
    <div class="row mb-5">
      <div class="col-12 mt-4">
        <ListUser
          label="Selecciona el usuario a eliminar"
          name="targetUser"
          v-model="userId"
          placeholder="Usuario"
          :danger="errors.has('data-user.targetUser')"
          :danger-text="errors.first('data-user.targetUser')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-12 mt-3">
        <div style="float: right" v-if="!showConfirm && !confirm">
          <b-button
            variant="primary"
            @click="attemptRemoveUser()"
          >
            Remover
          </b-button>
        </div>
        <div class="" v-if="showConfirm">
          <p class="warning-confirmation">
            ¿Estás seguro de remover el usuario?
          </p>
          <div class="text-right">
            <b-button
              class="ml-3"
              variant="outline-secondary"
              @click="discardChanges()"
            >
              Mejor no
            </b-button>
            <b-button
              class="ml-3"
              variant="primary"
              @click="saveChanges()"
            >
              Si, seguro
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  mixins: [],
  components: { ListUser },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      confirm: false,
      showConfirm: false,
      userId: ''
    };
  },
  watch: {},
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'modalUser';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Usuario', [
      'updateUserComppany',
      'removeUserCompany'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async attemptRemoveUser() {
      const isValid = await this.validateForm('data-user');
      if (!isValid) {
        return;
      }
      this.showConfirm = true;
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-user');
      if (!isValid) {
        return;
      }
      this.removeUserCompany({ usuarioId: this.userId });
      this.$emit('close-action');
      this.showConfirm = false;
      this.confirm = true;
    },
    async discardChanges() {
      this.showConfirm = false;
      this.confirm = false;
    }
  },
  created() {
    this.confirm = false;
  }
};
</script>
<style scoped>
.warning-confirmation {
  text-align: center;
  background-color: #ff9800;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
